export default __webpack_public_path__ + "static/media/e2.9ad06497.jpg";